import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { screenHeightLeftFromTop } from "Constants";
import { fetchadminissueTokenClose } from "AccountSettingsAction";
import ReportIssueitemList from "./reportissue-itemlist";
import LocaleStrings from "Languages";
import Loader from "Loader";

class CloseReportIssue extends Component {
  constructor(props) {
    super(props);

    // this.state = this.getInitialState();
    this.state = {
      loading: true,
      desc: LocaleStrings.accountsetting_report_loading_desc,
    };
  }

  componentDidMount() {
    let { user } = this.props;
    let clientid = user.clientid;
    if (clientid !== null && clientid !== "") {
      this.props.fetchadminissueTokenClose(
        this.props.session,
        clientid,
        (CallBackResponse) => {
          this.setState({ loading: false });
        }
      );
    }
  }

  renderissueList() {
    return _.map(this.props.adminissueListclose, (values, index) => {
      return (
        <ReportIssueitemList
          key={index}
          values={values}
          position={index}
          comesFrom="closeissue"
        />
      );
    });
  }

  render() {
    let { adminissueListclose, deviceSize } = this.props;
    let count = 0;
    if (adminissueListclose && adminissueListclose.length > 0) {
      count = adminissueListclose.length;
    }

    return (
      <div
        className="panel-body scrollable-content"
        style={{ height: deviceSize.height - screenHeightLeftFromTop }}>
        {this.state.loading ? (
          <div className="loader-container">
            <Loader />
            <div className="loader-info">{this.state.desc}</div>
          </div>
        ) : (
          <div>
            {LocaleStrings.accountsetting_addreport_noofcloseissue}{" "}
            <span className="">{count}</span>
            {adminissueListclose && adminissueListclose.length > 0 ? (
              <div className="panel-body scrollable-content">
                <table className="table">
                  <thead>
                    <tr>
                      <th>{LocaleStrings.accountsetting_reportissue_th0}</th>
                      {/* <th>{LocaleStrings.accountsetting_reportissue_th6}</th> */}
                      <th>{LocaleStrings.accountsetting_reportissue_th1}</th>
                      <th>{LocaleStrings.accountsetting_reportissue_th5}</th>
                      <th>{LocaleStrings.accountsetting_reportissue_th3}</th>
                      <th>{LocaleStrings.accountsetting_reportissue_th2}</th>
                      <th>{LocaleStrings.accountsetting_reportissue_th7}</th>
                      <th>{LocaleStrings.accountsetting_reportissue_th4}</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-background">
                    {this.renderissueList()}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    adminissueListclose: state.adminissueListclose,
  };
}

export default connect(mapStateToProps, {
  fetchadminissueTokenClose,
})(CloseReportIssue);
